export enum CloseDialogResult {
  disabled = 'disabled',
  continueEditing = 'continueEditing',
  cancelEditing = 'cancelEditing',
}

export type DialogButtonRole = 'primary' | 'secondary' | 'tertiary';

export interface DialogButton {
  role: DialogButtonRole;
  text: string;
}

export interface TextTokens {
  color?: string;
  align?: 'left' | 'right' | 'center' | 'justify';
  fontFamily?: string;
  fontSize?: string;
  fontStyle?: 'normal' | 'italic' | 'oblique';
  fontWeight?: number | 'normal' | 'bold' | 'bolder' | 'lighter';
  lineHeight?: string;
}

export interface DialogStyleTokens {
  title?: TextTokens;
  description?: TextTokens;
  buttons?: DialogButton[];
  dialog?: {
    radius?: string;
    width?: string;
  };
}

export interface DialogRequestDetail {
  title: string;
  description: string;
  buttons: DialogButton[];
  styles?: DialogStyleTokens;
  disableClose?: boolean;
}
